import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M5 17a2 2 0 1 0 4 0a2 2 0 1 0 -4 0","key":"svg-0"}],["path",{"d":"M15 17a2 2 0 1 0 4 0a2 2 0 1 0 -4 0","key":"svg-1"}],["path",{"d":"M5 17h-2v-4m-1 -8h11v12m-4 0h6m4 0h2v-6h-8m0 -5h5l3 5","key":"svg-2"}],["path",{"d":"M3 9l4 0","key":"svg-3"}]]

const IconTruckDelivery = createReactComponent('outline', 'truck-delivery', 'TruckDelivery', __iconNode);

export default IconTruckDelivery;